export default {
  TYPE: [
    { LABEL: 'Com histórico', VALUE: true },
    { LABEL: 'Sem histórico', VALUE: false },
  ],
};
